import React from 'react';
import { Form, Card, Input, Button, Radio, DatePicker, TimePicker } from 'antd';
import { connect } from 'dva';
import moment from 'moment';
import { formItemLayout, formatPrice } from 'utils/utils.js';
import styles from './Index.less';

const FormItem = Form.Item;
const RadioGroup = Radio.Group;
const { RangePicker } = DatePicker;

@connect(({ operationChargeItemPublishChargeItemSteps }) => ({
  selectedRows: operationChargeItemPublishChargeItemSteps.selectedRows,
  chargeItemFormValues: operationChargeItemPublishChargeItemSteps.chargeItemFormValues,
  chargeItemMode: operationChargeItemPublishChargeItemSteps.chargeItemMode,
}))
@Form.create()
export default class Step2 extends React.Component {
  static disabledSelectedDate(time) {
    if (time === undefined) {
      return false;
    }

    const dateObj = new Date();
    const nowYear = dateObj.getFullYear();
    const nowMonth = dateObj.getMonth();
    const nowDay = dateObj.getDate();
    const nowTimeValue = new Date(nowYear, nowMonth, nowDay, 0, 0, 0, 0).getTime();

    return time.valueOf() < nowTimeValue;
  }

  constructor(props) {
    super(props);

    this.handlePrevStep = this.handlePrevStep.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.renderSelectedCommodities = this.renderSelectedCommodities.bind(this);
    this.handleChangeMode = this.handleChangeMode.bind(this);
  }

  componentDidMount() {
    this.props.form.setFieldsValue(this.props.chargeItemFormValues);
  }

  handlePrevStep() {
    this.props.dispatch({ type: 'operationChargeItemPublishChargeItemSteps/decrementCurrentStep' });
  }

  handleSubmit(e) {
    e.preventDefault();

    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.props.dispatch({
          type: 'operationChargeItemPublishChargeItemSteps/saveChargeItemFormValues',
          values,
        });

        this.props.dispatch({
          type: 'operationChargeItemPublishChargeItemSteps/incrementCurrentStep',
        });
      }
    });
  }

  handleChangeMode(e) {
    this.props.dispatch({
      type: 'operationChargeItemPublishChargeItemSteps/saveChargeItemMode',
      mode: e.target.value,
    });
  }

  renderSelectedCommodities() {
    const { selectedRows } = this.props;

    return selectedRows.map(row => {
      const price =
        row.minPrice === row.maxPrice
          ? `￥${formatPrice(row.minPrice)}`
          : `￥${formatPrice(row.minPrice)}-￥${formatPrice(row.maxPrice)}`;

      return (
        <div key={row.commodityId} className="commodity-info-wrap">
          <span className="commodity-name">{row.name}</span>
          <span className="price">{price}</span>
        </div>
      );
    });
  }

  render() {
    const {
      chargeItemMode,
      chargeItemFormValues,
      form: { getFieldDecorator, getFieldValue, resetFields },
    } = this.props;

    return (
      <Card bordered={false} className={styles.root}>
        <Form onSubmit={this.handleSubmit} className={styles.root}>
          <FormItem {...formItemLayout} label="收费项目名">
            {getFieldDecorator('title', {
              rules: [
                { required: true, message: '请输入收费项目名' },
                { max: 50, message: '收费项目名不能多于50个字' },
              ],
            })(<Input placeholder="收费项目名不能多于50个字" />)}
          </FormItem>

          <FormItem {...formItemLayout} label="商品名">
            {this.renderSelectedCommodities()}
          </FormItem>

          <FormItem {...formItemLayout} label="缴费形式">
            {getFieldDecorator('necessary', {
              rules: [{ required: true, message: '请选择缴费形式' }],
            })(
              <RadioGroup>
                <Radio value={false}>自愿（可以选择【不参与】）</Radio>
                <Radio value>必交（不能选择【不参与】）</Radio>
              </RadioGroup>
            )}
          </FormItem>

          <FormItem {...formItemLayout} label="起止日期">
            {getFieldDecorator('time', {
              rules: [{ required: true, message: '请选择起止日期' }],
            })(
              <RangePicker
                disabledDate={Step2.disabledSelectedDate}
                onChange={() => {
                  resetFields(['gmtBeginTime', 'gmtEndTime']);
                }}
              />
            )}
          </FormItem>

          {getFieldValue('time') &&
            getFieldValue('time').length !== 0 && (
              <FormItem {...formItemLayout} label="起始时间">
                {getFieldDecorator('gmtBeginTime', {
                  initialValue: chargeItemFormValues.gmtBeginTime,
                  rules: [
                    { required: true, message: ' ' },
                    {
                      validator: (rule, value, callback) => {
                        if (!value) {
                          return callback('请选择起始时间');
                        }

                        const gmtBeginDateValue = moment(getFieldValue('time')[0]).startOf('day');
                        const now = moment();

                        // 如果“起始日期”选择为当天，那么“起始时间”不能小于当前时间
                        if (
                          moment(now)
                            .startOf('day')
                            .diff(gmtBeginDateValue) >= 0
                        ) {
                          const selectHour = value.hour();
                          const selectMinute = value.minute();
                          const selectSecond = value.second();
                          const nowHour = now.hour();
                          const nowMinute = now.minute();
                          const nowSecond = now.second();

                          if (
                            selectHour < nowHour ||
                            (selectHour === nowHour && selectMinute < nowMinute) ||
                            (selectHour === nowHour &&
                              selectMinute === nowMinute &&
                              selectSecond < nowSecond)
                          ) {
                            return callback('起始时间不能小于当前时间');
                          }
                        }

                        return callback();
                      },
                    },
                  ],
                })(<TimePicker />)}
              </FormItem>
            )}

          {getFieldValue('time') &&
            getFieldValue('time').length !== 0 && (
              <FormItem {...formItemLayout} label="截止时间">
                {getFieldDecorator('gmtEndTime', {
                  initialValue: chargeItemFormValues.gmtEndTime,
                  rules: [
                    { required: true, message: ' ' },
                    {
                      validator: (rule, value, callback) => {
                        if (!value) {
                          return callback('请选择截止时间');
                        }

                        const gmtBeginDateValue = moment(getFieldValue('time')[0]).startOf('day');
                        const gmtEndDateValue = moment(getFieldValue('time')[1]).startOf('day');
                        const gmtBeginTimeValue = moment(getFieldValue('gmtBeginTime'));

                        // 如果“起始日期”和“截止日期”都选择为当天，那么“截止时间”不能小于“起始时间”
                        if (gmtBeginDateValue.diff(gmtEndDateValue) === 0) {
                          const beginHour = gmtBeginTimeValue.hour();
                          const beginMinute = gmtBeginTimeValue.minute();
                          const beginSecond = gmtBeginTimeValue.second();
                          const endHour = value.hour();
                          const endMinute = value.minute();
                          const endSecond = value.second();

                          if (
                            beginHour > endHour ||
                            (beginHour === endHour && beginMinute > endMinute) ||
                            (beginHour === endHour &&
                              beginMinute === endMinute &&
                              beginSecond > endSecond)
                          ) {
                            return callback('截止时间不能小于起始时间');
                          }
                        }

                        return callback();
                      },
                    },
                  ],
                })(<TimePicker />)}
              </FormItem>
            )}

          <FormItem {...formItemLayout} label="收费方式">
            {getFieldDecorator('mode', {
              onChange: this.handleChangeMode,
              initialValue: chargeItemMode,
              rules: [{ required: true, message: '请选择收费方式' }],
            })(
              <RadioGroup>
                <Radio value="NOTIFICATION">通知收费</Radio>
                <Radio value="SCAN">扫码收费</Radio>
              </RadioGroup>
            )}
          </FormItem>

          <FormItem className="operation-button-wrap">
            <Button onClick={this.handlePrevStep}>上一步</Button>
            <Button type="primary" htmlType="submit">
              下一步
            </Button>
          </FormItem>
        </Form>
      </Card>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/Operation/ChargeItem/PublishChargeItemSteps/Step2/Index.js